export const USER_SET_ACCESS_TOKEN = 'user.set-access-token';
export const USER_SET_USER_MODEL = 'user.set-user-model';
export const USER_CLEAR_REQUISITES = 'user.clear-requisites';
export const USER_PREFERENCES_WAS_UPDATED = 'user.preferences-was-updated';
export const USER_SET_PREFERENCES = 'user.set-preferences';
export const USER_UPDATE_PREFERENCE = 'user.update-preferences';

export const USER_FETCH_MODEL = 'user.fetch-model';
